<template>
  <!-- 赠险 -->
  <div class="main-container">
    <div class="body">
      <div class="search-box min gauge_20_form_bottom">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input type="text" v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">销售状态</span>
          <Select v-model="searchParams.salesStatus" placeholder="请选择" clearable>
            <Option value="null">全部</Option>
            <Option value="2">在售</Option>
            <Option value="1">停售</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">上架状态</span>
          <Select v-model="searchParams.publishStatus" placeholder="请选择" clearable>
            <Option value="null">全部</Option>
            <Option value="1">下架</Option>
            <Option value="2">上架</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
        </div>
      </div>
      <div class="tools-box">
        <div class="info-box">
          <div class="text2">赠险产品：</div>
          <div class="text3">{{ statistics.num || 0 }}</div>
          <div class="text2 two">已投保份额：</div>
          <div class="text3">{{ statistics.payGiftNum || 0 }}</div>
          <div class="text2 two">可用份额：</div>
          <div class="text3">{{ statistics.remainGiftNum || 0 }}</div>
        </div>
        <Button type="primary" @click="daochu()" ghost>导出</Button>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="publishStatus">
            <Tooltip v-if="row.id == undefined" content="总份额为0不可上架  " placement="top-start" transfer>
              <i-switch
                :disabled="row.id == undefined"
                v-model="row.publishStatus"
                :true-value="2"
                :false-value="1"
                :before-change="() => row.id && changeStatus(row)"
              />
            </Tooltip>
            <i-switch
              v-else
              :disabled="row.id == undefined"
              v-model="row.publishStatus"
              :true-value="2"
              :false-value="1"
              :before-change="() => row.id && changeStatus(row)"
            />
          </template>
          <template slot-scope="{ row }" slot="action">
            <span
              class="table-btn"
              :class="{ 'disabled': row.id == undefined }"
              @click="
                curRow = row;
                row.id && $refs.distributionModal.open(row);
              "
              >分配业务员</span
            >
            <span
              class="table-btn"
              :class="{ 'disabled': row.id == undefined }"
              @click="
                curRow = row;
                row.id && $refs.isDistribModal.open(row);
              "
              >已分配业务员</span
            >
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
    </div>
    <!-- 分配业务员 -->
    <distribution-modal ref="distributionModal" :remainGiftNum="curRow.remainGiftNum" @reload="getList()"></distribution-modal>
    <!-- 已分配业务员 -->
    <is-distrib-modal ref="isDistribModal" :remainGiftNum="curRow.remainGiftNum" @reload="getList()"></is-distrib-modal>
  </div>
</template>
<script>
import DistributionModal from './components/distributionModal.vue';
import IsDistribModal from './components/isDistribModal.vue';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, common, config],
  data: () => ({
    curRow: {},
    // 统计数据
    statistics: {},
    searchParams: {
      queryType: 2, //1 运营后台 2  商户后台赠险管理
      salesStatus: 'null',
      publishStatus: 'null',
      productName: ''
    },
    loading: false,
    pageNo: 1,
    pageSize: 10
  }),
  components: {
    DistributionModal,
    IsDistribModal
  },
  created() {
    this.initListParams('/buz/giveawayProduct/queryProductList');
  },
  activated() {
    this.getList();
  },
  methods: {
    daochu() {
      if (!this.$units.pointAction('recruiting_3_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/giveawayProduct/exportProductList', params, 'POST');
    },
    // 设置权限头
    setReqParams(params) {
      params.apiPermissionCode = 'recruiting_3_0';
    },
    // 转化参数
    setListParams(params) {
      if (params.salesStatus == 'null') {
        delete params.salesStatus;
      }
      if (params.publishStatus == 'null') {
        delete params.publishStatus;
      }
    },
    // 修改状态
    changeStatus(row) {
      return new Promise((resolve, reject) => {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>请确认是否更改产品上架状态</p>',
          onOk: () => {
            this.$http({
              url: '/buz/giveawayProduct/updateProduct',
              type: 'POST',
              data: {
                id: row.id,
                publishStatus: row.publishStatus == 1 ? 2 : 1
              }
            }).then(res => {
              resolve();
              this.getList();
              this.$notice.success('修改成功');
            });
          },
          onCancel: () => {
            reject();
          }
        });
      });
    },
    getList(pageNum) {
      const params = Object.assign({}, this.searchParams);
      if (pageNum) {
        this.pageNum = pageNum;
      }
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.setListParams(params);
      this.listLoading = true;
      if (!this.listUrl) {
        return;
      }
      let reqParams = {
        type: 'POST',
        url: this.listUrl,
        data: params
      };
      this.$http(reqParams)
        .then(res => {
          // 翻页无数据回退上一页 只有一页不处理
          const list = res.data.data.records;
          if ((!list || list.length == 0) && this.pageNum != 1) {
            this.pageNum--;
            this.getList();
            return;
          }
          this.statistics = res.data.statistics;
          this.total = res.data.data.total;
          this.tableData = list;
          list.forEach(item => {
            if (item.id == this.curRow.id) {
              this.curRow = item;
            }
          });
        })
        .finally(e => {
          this.listLoading = false;
        });
    }
  }
};
</script>
<style lang='scss' scoped>
@import './index';
.ivu-switch {
  opacity: 0.4;
}
.ivu-switch-checked {
  opacity: 1;
}
</style>